export const materialPriceUnitField = {
    "ROW_NUMBER": "номер строки, по дефолтному \"№ п/п\"",
    "ARTICLE_NUMBER_SUPPLIER": "Артикул пост.",
    "NAME_SUPPLIER": "Наименование пост.",
    "ARTICLE_NUMBER": "Артикул",
    "NAME": "Наименование",
    "UNIT_NAME": "Ед. изм.",
    "QUANTITY": "Кол.",
    "AMOUNT_IN_CURRENCY_ARRIVAL": "Сумма в текущей валюте",
    "PRICE_IN_CURRENCY_ARRIVAL": "Цена в текущей валюте",
    "EXCHANGE_RATE_TO_BASE_CURRENCY_BASE_MATERIALS": "курс БВ",
    "PRICE_IN_CURRENCY_BASE": "Цена БВ",
    "EXCHANGE_RATE_TO_ALTERNATIVE_CURRENCY_BASE_MATERIALS": "курс АВ",
    "PRICE_IN_CURRENCY_ALTERNATIVE": "Цена АВ",
    "BASE_PRICE": "Баз. цена",
    "REAL_BASE_PRICE": "Тек. цена",
    "PRICE_INCREASE_IN_BASE_PRICE": "Расх., %",
    "EXCHANGE_RATE_TO_BASE_PRICE": "курс БЦ",
    "COEFFICIENT_CURRENCY_BASE_PRICE": "Кф. курса БЦ",
    "LOSSES": "Потери",
}